import { ElementType } from 'react';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import type { StackProps } from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';

export type SummaryPanelVariant = 'compact' | 'full';

interface PanelSectionHeaderProps extends StackProps {
  title: string;
  icon?: ElementType;
  iconSx?: SxProps<Theme>;
  variant?: SummaryPanelVariant;
  titleSx?: SxProps<Theme>;
}

export default function PanelSectionHeader({
  title,
  icon: Icon,
  iconSx,
  variant = 'full',
  titleSx,
  ...stackProps
}: PanelSectionHeaderProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.75}
      {...stackProps}
      sx={{ mb: 2, mt: 3 }}
    >
      {Icon && (
        <SvgIcon
          component={Icon}
          sx={[
            (theme) => ({
              fontSize: 20,
              color: theme.palette.semantic.icon.violet,
            }),
            ...(Array.isArray(iconSx) ? iconSx : [iconSx]),
          ]}
        />
      )}
      <Typography
        variant={variant === 'compact' ? 'body2' : 'body1'}
        sx={titleSx}
      >
        {title}
      </Typography>
    </Stack>
  );
}
